import { useConfigurationClinicDetailAPI } from "@/app/hooks/api_hooks/configuration/useConfigurationClinicDetailAPI";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useFeatureAccess } from "@/app/hooks/useFeatureAccess";
import { useEffect } from "react";
import { BLUE7_BORIVALI_CLINIC_ID } from "@/constants";

const LetterHeader = () => {
  const { clinicDetails, execute: fetchClinicDetail } = useConfigurationClinicDetailAPI();
  const mappedClinicID = useAppSelector((state) => state?.root?.UIStates?.mappedClinicId ?? "");

  // RBAC: CERTIFICATE_DOGGYWORLD_LETTERHEAD — legacy role: clinic_ops_doggyworld
  const isDoggyworld = useFeatureAccess("CERTIFICATE_DOGGYWORLD_LETTERHEAD");
  const isBlue7BorivaliClinic = mappedClinicID === BLUE7_BORIVALI_CLINIC_ID;

  const logo = isBlue7BorivaliClinic
    ? "https://vetic-img.s3.ap-south-1.amazonaws.com/website/Website-Astro/icons/Blue7vetsLogo.png"
    : isDoggyworld
      ? "https://vetic-img.s3.ap-south-1.amazonaws.com/quick_commerce//misc/DW+Logo+2logo.png"
      : "https://vetic-img.s3.ap-south-1.amazonaws.com/website/Website-Astro/Footer/LogoandLocation.webp";

  useEffect(() => {
    fetchClinicDetail(mappedClinicID);
  }, [mappedClinicID]);

  return (
    <div className="w-full flex flex-col  bg-white  py-3 -mt-6">
      <div className="flex items-center justify-center">
        <img
          src={logo}
          alt="Vetic Logo"
          className="h-20 w-40 object-contain"
        />
      </div>
      <div className="w-1/3 ">
        <h1 className="text-2xl font-extrabold text-gray-900">
          {isBlue7BorivaliClinic ? "BLUE7VETS" : isDoggyworld ? "Doggy World" : "Vetic Pet Clinic"}
        </h1>
        <p className="text-gray-700 text-sm   leading-relaxed">
          <span className="font-semibold">Address:</span> {clinicDetails?.clinic_data?.address} , Contact:{" "}
          {clinicDetails?.clinic_data?.mobile} ,Visit:{" "}
          <a className="text-blue-400" href="https://vetic.in/">
            Vetic
          </a>
        </p>
      </div>
      <div className="mt-1"></div>
      <hr />
    </div>
  );
};

export default LetterHeader;
